import { KolProfile } from '@/types/campaign'

const REQUIRED_STRING_FIELDS: readonly (keyof KolProfile)[] = [
  'fullName',
  'phone',
  'email',
  'sports',
  'address',
  'city',
  'district',
  'ward',
]

export const isKolProfileComplete = (
  profile?: KolProfile | null
): profile is KolProfile => {
  if (!profile) return false
  if (!profile.socialLinks?.length) return false
  return REQUIRED_STRING_FIELDS.every((field) => !!profile[field])
}
